<template>
  <div class="wage-premium-collapse">
    <button
      type="button"
      class="wage-premium-collapse__row"
      :class="{ 'wage-premium-collapse__row--with-fix': showManualToggle }"
      :aria-expanded="expanded"
      @click="emit('update:expanded', !expanded)"
    >
      <span class="wage-payroll-grid__label wage-premium-collapse__label">{{ label }}</span>
      <input
        v-if="showManualToggle"
        type="checkbox"
        class="wage-insurance-single__fix-cb"
        :checked="manualAdjustEnabled"
        :disabled="manualToggleDisabled"
        @click.stop
        @change="onManualToggle($event)"
      />
      <span class="wage-premium-collapse__value">
        <span class="wage-premium-collapse__sum">{{ sumDisplay }}</span>
        <v-icon size="12" class="wage-premium-collapse__chevron">
          {{ expanded ? 'mdi-chevron-down' : 'mdi-chevron-right' }}
        </v-icon>
      </span>
    </button>
    <div v-show="expanded" class="wage-premium-collapse__body">
      <slot />
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';

const props = withDefaults(
  defineProps<{
    expanded: boolean;
    sum: number;
    formatSum: (amount: number) => string;
    showManualToggle?: boolean;
    manualAdjustEnabled?: boolean;
    manualToggleDisabled?: boolean;
    label?: string;
  }>(),
  {
    label: '연장야간휴일',
  }
);

const emit = defineEmits<{
  'update:expanded': [value: boolean];
  'update:manualAdjustEnabled': [value: boolean];
}>();

const onManualToggle = (event: Event) => {
  const checked = (event.target as HTMLInputElement).checked;
  emit('update:manualAdjustEnabled', checked);
};

const sumDisplay = computed(() => {
  if (props.sum <= 0) return '';
  return props.formatSum(props.sum);
});
</script>
